'use client';

import BranchesMap from '@/_components/Map/Branches';
import { useBranchList } from '@/_service/branch.service';
import {
  Box,
  Button,
  Flex,
  HStack,
  IconButton,
  Input,
  Stack,
  Text,
} from '@chakra-ui/react';
import React, { useRef, useState } from 'react';
import { ClearIcon, SearchIcon } from '@/_assets/icon-components';
import { useTranslations } from 'next-intl';
import { InputGroup } from '@/components/ui/input-group';
import { ISavedBranch } from '@/_store/types';
import BranchesContent from '@/_components/Branches/_components/content';
import { useActiveBrand } from '@/_hooks/useActiveBrand';

const BranchesDesktop = ({ onClose, onChange }: { onClose: () => void, onChange: (branch: ISavedBranch) => void }) => {
  const t = useTranslations();
  const branchRefs = useRef<Record<string, HTMLDivElement | null>>({});

  const shipperId = useActiveBrand()

  const [search, setSearch] = useState('');
  const [selectedBranch, setSelectedBranch] = useState<ISavedBranch | null>(null);

  const onConfirm = () => {
    if (selectedBranch) {
      onChange(selectedBranch);
      setSelectedBranch(null);
      onClose();
    }
  };

  const { data } = useBranchList({
    params: { page: 1, limit: 100, search },
    props: { enabled: true },
    shipperId
  });

  return (
    <Flex gap={6} w={'full'} p={6} h={'full'} bg='background.card' color='text'>
      <Stack gap={0} w={'1/2'}>
        <Text color={'text'} fontWeight={700} fontSize={20}>
          {t('selected_branch_for_takeaway')}
        </Text>
        <HStack gap={2} mt={5}>
          <InputGroup
            flex='1'
            endElement={
              search && (
                <IconButton variant={'ghost'} onClick={() => setSearch('')}>
                  <ClearIcon />
                </IconButton>
              )
            }
            startElement={<SearchIcon />}
          >
            <Input
              size={'xl'}
              rounded={16}
              value={search}
              border={'none'}
              bg={'background'}
              outlineColor={'primary'}
              onChange={(e) => setSearch(e.target.value)}
              placeholder={t('location.search_by_branch_name')}
            />
          </InputGroup>
        </HStack>
        <Text color={'text.muted'} fontSize={'sm'} mt={4}>
          {t('total_branches')}: {data?.count || 0}
        </Text>
        <BranchesContent
          data={data?.branches}
          branchRefs={branchRefs}
          selectedBranch={selectedBranch}
          setSelectedBranch={setSelectedBranch}
        />
        <Button
          mt={6}
          fontSize={16}
          size={'xl'}
          height={'56px'}
          bg='primary'
          color='primary.text'
          _hover={{ bg: 'primary.hover' }}
          w={'full'}
          rounded={16}
          onClick={onConfirm}
          disabled={!selectedBranch}
        >
          {t('select')}
        </Button>
      </Stack>
      <Box
        w={'1/2'}
        overflow={'hidden'}
        rounded={16}
        position={'relative'}
        h={'100%'}
      >
        <BranchesMap
          isSelected={true}
          data={data?.branches}
          onClose={() => onClose()}
          selectedBranch={selectedBranch}
          setSelectedBranch={setSelectedBranch}
        />
      </Box>
    </Flex>
  );
};

export default BranchesDesktop;
